import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { serviceMap } from "@/data/services";

export const Route = createFileRoute("/services/$slug")({
  head: ({ params }) => {
    const s = serviceMap[params.slug];
    const title = s?.seo?.title || (s ? `${s.title} | BAZZAR 3D` : "Service | BAZZAR 3D");
    const description = s?.seo?.description || s?.subtitle || "Integrated digital solutions to grow your business. حلول رقمية متكاملة لنمو أعمالك.";
    const keywords = s?.seo?.keywords;
    const image = s?.seo?.ogImage || s?.bannerImage;
    const meta: Array<Record<string, string>> = [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
    ];
    if (keywords) meta.push({ name: "keywords", content: keywords });
    if (image) {
      meta.push({ property: "og:image", content: image });
      meta.push({ name: "twitter:image", content: image });
    }
    return { meta };
  },
  component: lazyRouteComponent(() => import("@/pages-lazy/services-slug")),
});